import { ReactComponentManifest } from "web/entrypoints/common/setup";
import ExpressCheckoutProductPage from "web/react/components/express-checkout-product-page/express-checkout-product-page";
import Footer from "web/react/components/footer/footer";
import HomepageDesignerRail from "web/react/components/homepage-designer-rail/homepage-designer-rail";
import HomepageOverlay from "web/react/components/homepage-overlay/homepage-overlay";
import HomepageStoreRail from "web/react/components/homepage-store-rail/homepage-store-rail";
import ProductArea from "web/react/components/product-area/product-area";
import RelatedProductsRails from "web/react/components/related-products-rails/related-products-rails";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import RetailerPromotionHub from "web/react/components/retailer-promotion-hub/retailer-promotion-hub";
import UnsubscribeOverlay from "web/react/components/unsubscribe-overlay/unsubscribe-overlay";
import ProductPage from "web/react/pages/product/in-stock/in-stock";
import OOSProductPage from "web/react/pages/product/out-of-stock/out-of-stock";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    ExpressCheckoutProductPage,
    Footer,
    HomepageDesignerRail,
    HomepageOverlay,
    HomepageStoreRail,
    OOSProductPage,
    ProductArea: withRedux(ProductArea as any), // TODO: ProductArea's proptypes are broken
    ProductPage,
    RelatedProductsRails,
    RelatedSearchesRail,
    RetailerPromotionHub,
    UnsubscribeOverlay,
};

export default components;
